var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_3991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.642822 -6.10352e-05H14.6428V13.9999H0.642822V-6.10352e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_3991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.56755 0.410095C3.63554 0.410095 2.74151 0.780384 2.08231 1.43948C1.42332 2.0986 1.05298 2.99255 1.05298 3.92467C1.05298 9.26258 5.3801 13.5898 10.7181 13.5898C11.6501 13.5898 12.5441 13.2195 13.2033 12.5604C13.8623 11.9013 14.2327 11.0073 14.2327 10.0752L9.83943 8.31791L8.96079 10.5145H8.96033C6.29169 10.5145 4.12825 8.35113 4.12825 5.68241V5.68197L6.32485 4.80333L4.56755 0.410095Z",
    stroke: "black",
    strokeWidth: 1.05957,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0539b2542b748f4a5cac0673d633d8c3.svg";
export { ForwardRef as ReactComponent };